import { MdDescription, MdOutlineError } from 'react-icons/md';
import { FaSearch, FaPlus } from "react-icons/fa";
import HeaderContainers from '../HeaderContainers/HeaderContainers';
import InputPadrao from '../InputPadrao/InputPadrao';
import './FiltroDepartamentoContainer.css';
import InputSelectPadrao from '../InputSelectPadrao/InputSelectPadrao';
import BotaoCustom from '../BotaoCustom/BotaoCustom';
import { getSituacaoCadastro } from '../../services/situacaoCadastroService';
import { useContext, useEffect, useState } from 'react';
import { DepartamentoFilterContext } from '../../context/DepartamentoFilterContext';
import NotifyUtils from '../../utils/NotifyUtils';
import BotaoPadrao from '../BotaoPadrao/BotaoPadrao';
import { IoChatbox } from 'react-icons/io5';
import { useTranslation } from 'react-i18next';

function FiltroDepartamentoContainer({
    podeCadastrar
}) {
    const { t } =  useTranslation();
    const { handleClear, departamentoFilter, handleChange, handleSearch } = useContext(DepartamentoFilterContext);
    const [ resetaFiltroSitCadastro, setResetaFiltroSitCadastro ] = useState(false);

    const limparFiltros = () => {
        NotifyUtils.sucesso(t("retira-filtros")); 
        setResetaFiltroSitCadastro(!resetaFiltroSitCadastro);
        handleClear();
    };

    const pesquisar = () => {
        handleSearch();
        NotifyUtils.sucesso(t("pesquisa-sucesso")); 
    }

    // Função que direciona para a página de cadastro de departamento
    const direcionaParaCadastroDepartamento = () => {
        if(!podeCadastrar) {
            NotifyUtils.aviso(t("sem-empresa-cadastrada"));
            return;
        }

        window.location.href = "/cadastrar-departamento";
    }

    const [situacaoCadastro, setSituacaoCadastro] = useState(null);
    useEffect(() => {
        getSituacaoCadastro().then((situacaoCadastro) => {
            setSituacaoCadastro(situacaoCadastro);
        }).catch((error) => {
            console.error(error);
        });
    }, []);

    let situacoesCadastro = [];
    if (situacaoCadastro !== null) {
        situacoesCadastro = situacaoCadastro;
    } else {
        return <div>Loading...</div>;
    }

    return (
        <div>
            <HeaderContainers texto={t("selecione-filtros")} />

            <div className="container-filtro-departamentos">
                <div className="container-inputs-filtro-departamento">
                    <InputPadrao
                        onChange={handleChange}
                        className={"input-nome-departamento"}
                        inputPara={"nomeDepartamento"}
                        titulo={t("nome-departamento")}
                        icone={<MdDescription />}
                        placeholder={t("place-holder-departamento")}
                        obrigatorio={false}
                        type={"text"}
                        value={departamentoFilter.nomeDepartamento}
                        name={"nome-departamento"}
                    />

                    <InputPadrao
                        onChange={handleChange}
                        className={"input-sigla-departamento"}
                        inputPara={"sigla"}
                        titulo={t("sigla")}
                        icone={<IoChatbox />}
                        placeholder={t("place-holder-siglas-departamento")}
                        obrigatorio={false}
                        type={"text"}
                        value={departamentoFilter.sigla}
                        name={"sigla-departamento"}
                    />

                    <InputSelectPadrao
                        className={"input-situacao-cadastro-filtro-departamento"}
                        titulo={t("situacao-cadastro")}
                        obrigatorio={false}
                        name={"situacao-cadastro"}
                        inputPara={"situacaoCadastro"}
                        onChange={handleChange}
                        placeholder={t("place-holder-sitCad")}
                        options={situacoesCadastro}
                        value={departamentoFilter.situacaoCadastro}
                        icone={<MdOutlineError />}
                        resetaFiltro={resetaFiltroSitCadastro}
                    />
                </div>

                <div className="botoes-filtro-departamentos">
                    <BotaoPadrao
                        texto={t("botao-limpa-filtros")}
                        icone={null}
                        acaoDeClicar={limparFiltros}
                    />

                    <BotaoCustom
                        acaoDeClicar={pesquisar}
                        icone={<FaSearch />}
                        texto={t("botao-pesquisar")}
                        cancelar={false}
                    />
                    
                    <BotaoCustom
                        acaoDeClicar={direcionaParaCadastroDepartamento}
                        icone={<FaPlus />}
                        texto={t("botao-cadastra-departamento")}
                        cancelar={true}
                    />
                </div>
            </div>
        </div>
    )
}

export default FiltroDepartamentoContainer;